const english_interview_ids = ['9b13f125-8003-40b3-8b4d-a81c390fef7f', '9b13f125-8003-40b3-8b4d-a81c390fef7f'];

const commonConfig = {
    version: process.env.REACT_APP_VERSION,
    ga_4: process.env.REACT_APP_GA_4,
    url: process.env.REACT_APP_SHARE_URL,
    question_amount: 5,
    api:{
        lambda: process.env.REACT_APP_LAMBDA_URL,
    },
  
    resume: {
        upload_x_api_key: process.env.REACT_APP_UPLOAD_RESUME_X_API_KEY,
        upload_url: process.env.REACT_APP_UPLOAD_RESUME_URL,
        lambda_url: process.env.REACT_APP_LAMBDA_URL
    },
    report_api:{
        url: process.env.REACT_APP_REPORT_API,
        recommend_url: process.env.REACT_APP_REPORT_RECOMMEND_API
    },
    quiz:{
        url: process.env.REACT_APP_QUIZ_API_URL
    },
    firebase:{
        api_key : process.env.REACT_APP_FIREBASE_API_KEY,
        auth_domain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        project_id: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storage_bucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messaging_sender_id: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        app_id: process.env.REACT_APP_FIREBASE_APP_ID
    },
    partner:{
        profi: process.env.REACT_APP_PROFI_URL,
        english_interview_ai: process.env.REACT_APP_ENGLISH_INTERVIEW_AI_URL
    },
    language: {
        english_locked_ids: process.env.REACT_APP_ENGLISH_LOCKED_IDS ? 
            process.env.REACT_APP_ENGLISH_LOCKED_IDS.split(',').map(id => id.trim()) : 
            ['9b13f125-8003-40b3-8b4d-a81c390fef7f']
    },
    by_pass_english_locked: english_interview_ids
 };
 
 
 // Generate final config by merging the common config with any environment-specific overrides
 const getConfig = () => {
     return {
         ...commonConfig
     };
 };
 
 const config = getConfig();
 
 export default config;
 